export default __webpack_public_path__ + "static/media/photo3.26a2ae6a.jpg";